import { GlobalService } from './../global.service';
import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { LoaderService } from '../loder_service/loader.service';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})

export class SigninComponent implements OnInit {
  signinForm: FormGroup;
  phone_no: String;
  password: String;

  public user_id: any;
  

  constructor(public globalService:GlobalService, public storage:Storage, public restApi:DataService, public toastService:LoaderService, private router: Router, public fb:FormBuilder) { 


 this.user_id = localStorage.getItem('user_id');
  
 if(this.user_id){
       this.router.navigate(['/home'])
     }


 
    //this.requestHeader.append("Accept", 'application/json');
    this.signinForm = fb.group({
      "phone_no"      :  ["", Validators.required],
      "password"      :  ["", Validators.required],
   });
  }

  ngOnInit() {

  }


  doLogin(){
    this.toastService.showLoader('');
    console.log(this.signinForm.value);
   

  
    let value=this.signinForm.value;
    if(this.signinForm.valid){
        let postprams={
         phone_number:value.phone_no,
         password:value.password,
         cart_session:localStorage.getItem('cart_session')
        }
        this.restApi.login(postprams).subscribe((data:any)=>{
            if(data.result==1){
              this.toastService.create('You have successfully logged In')
              this.toastService.hideLoader();
              


              localStorage.setItem('user_id',data.user_id);
              localStorage.setItem('user_name',data.user_fname);
              localStorage.setItem('user_image', data.user_image);
              localStorage.setItem('user_mobile', data.user_mobile);
              localStorage.setItem('refferal_id', data.refferal_id);
              localStorage.setItem('pincode', data.pincode);
              
              this.router.navigate(['/home'])
              this.globalService.publishSomeData({
                user_name:data.user_fname,
                user_image:data.user_image,
                user_mobile:data.user_mobile,
                user_id:data.user_id
            });
            }else{
              this.toastService.create('Invalid username / password')
              this.toastService.hideLoader();
            }
        },(error:any)=>{
              this.toastService.hideLoader();
              this.toastService.create('Having some issues from serve end ')
        })
    }else{
      this.toastService.create('Please enter your credentials')
      this.toastService.hideLoader();

    }
 
  }
register(){
  this.router.navigate(['/register'])
}
skipLogin(){
  this.router.navigate(['/home'])
  this.globalService.publishSomeData({
    user_id:null
});
}
forgot(){

  this.router.navigate(['/otpverify'])
}
}
